import React from 'react'
import Header from '../include/Header'
import Sidebar from '../include/Sidebar'
import { Link, useNavigate } from 'react-router-dom'

const Profile = () => {

    const navigate = useNavigate();

    return (
        <div className="main-wrapper">
            <Header />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="page-title">Profile</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Profile</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-3 p-3" style={{ maxWidth: "540px", position: "relative" }}>
                        <div className="row g-0 d-flex align-center">
                            <div className="col-md-4 profileImg profile-data">
                                <img
                                    src={localStorage.getItem('PAY_ADMIN_IMG')}
                                    alt="Trendy Pants and Shoes"
                                    className=""
                                />
                            </div>
                            <div className="col-md-8">
                                <div className="card-body profile-data-text">
                                    <h5 className="card-title mb-2">{localStorage.getItem('PAY_ADMIN_NAME')}</h5>
                                    <p className="card-text">
                                        <strong>Email</strong> : {localStorage.getItem('PAY_ADMIN_EMAIL')}
                                    </p>
                                    {/* <button className='btn btn-primary'>Edit</button> */}
                                </div>
                            </div>

                        </div>
                        <div className='editBtn'>
                            <button className='btn btn-outline-secondary' onClick={() => navigate('/admin/edit-profile')}>
                                <i className="fa-solid fa-pencil"></i>
                            </button>
                        </div>
                    </div>
        
                </div>
            </div>
        </div>
    )
}

export default Profile